import AuthManager from "../../common/auth/Manager";
import ClientApiManager from '../../modules/user/api/client'

const isAuthorized = async (to, from, next) => {

  try {
    let clientId = to && to.params && to.params.clientId
      ? parseInt(to.params.clientId)
      : null;

    let response = await ClientApiManager.hasAccess(clientId);
    let {data: result} = response.data;

    if (!AuthManager.isGuest() && AuthManager.can('view_client') && (result && result.access)) {
      next()
    } else {
      next({name: 'login'})
    }
  } catch (e) {
    next({name: 'client'})
  }

};

export default isAuthorized;




// WEBPACK FOOTER //
// ./src/router/hooks/canViewCleint.js